import Vue from 'vue';
import VueI18n from 'vue-i18n';
import french from './locales/fr.json';
import english from './locales/en.json';

Vue.use(VueI18n);

let locale = navigator.language;

locale = locale.substring(0, 2);

const i18n = new VueI18n({
  locale,
  fallbackLocale: 'fr',
  messages: {
    fr: french.messages,
    en: english.messages,
  },
  dateTimeFormats: {
    fr: french.dateTimeFormats,
    en: english.dateTimeFormats,
  },
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js